<h1 mat-dialog-title>
  <span translate="account/links/config_edition/transformation_dialog_title"> </span>
  <mat-icon mat-dialog-close class="alc-cursor-pointer">close</mat-icon>
</h1>
<div mat-dialog-content>
  <p>
    <mat-form-field>
      <mat-label translate="account/links/transformations/when-hostname"></mat-label>
      <input
        #hostnameControl="ngModel"
        matInput
        required
        [pattern]="hostnameRegex"
        [(ngModel)]="data.transformation.hostname"
        (ngModelChange)="updateTransformationExample()"
        type="text" />
      <mat-error
        *ngIf="hostnameControl.invalid && hostnameControl.errors?.required"
        translate="common/form_errors/required"></mat-error>
      <mat-error
        *ngIf="hostnameControl.invalid && hostnameControl.errors?.pattern"
        translate="account/links/transformations/hostname-pattern-error-message"></mat-error>
    </mat-form-field>
  </p>
  <div>
    <span translate="account/links/transformations/for-example"></span> &nbsp;
    <code>{{ data.transformation.example }}</code>
  </div>
  <section>
    <h6 class="description" translate="account/links/transformations/then-execute"></h6>
    <div class="action-container" *ngFor="let action of data.transformation.actions; index as index">
      <strong>{{ index + 1 }}. </strong>
      <div>
        <mat-form-field>
          <mat-label> <span translate="account/links/config_edition/action_type_label"></span> </mat-label>
          <mat-select
            aria-label="action type"
            [(ngModel)]="action.type"
            (openedChange)="updateActionOnTypeChange(action)">
            <mat-option *ngFor="let item of actionTypesChoices" [value]="item.id">{{ item.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="action-details" *ngIf="action.type === 'add-argument'">
          <mat-form-field>
            <mat-label translate="account/links/transformations/actions/add-argument/name"></mat-label>
            <input matInput [(ngModel)]="action.name" type="text" />
          </mat-form-field>
          <mat-form-field>
            <mat-label translate="account/links/transformations/actions/add-argument/value"></mat-label>
            <input matInput [(ngModel)]="action.value" type="text" />
          </mat-form-field>
        </div>
        <div class="action-details" *ngIf="action.type === 'set-argument'">
          <mat-form-field>
            <mat-label translate="account/links/transformations/actions/set-argument/name"></mat-label>
            <input matInput [(ngModel)]="action.name" type="text" />
          </mat-form-field>
          <mat-form-field>
            <mat-label translate="account/links/transformations/actions/set-argument/value"></mat-label>
            <input matInput [(ngModel)]="action.value" type="text" />
          </mat-form-field>
        </div>
        <div class="action-details" *ngIf="action.type === 'set-argument-variable'">
          <mat-form-field>
            <mat-label translate="account/links/transformations/actions/set-argument-variable/name"></mat-label>
            <input matInput [(ngModel)]="action.name" type="text" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>
              <span translate="account/links/transformations/actions/set-argument-variable/value"></span>
            </mat-label>
            <mat-select
              aria-label="action value"
              [(ngModel)]="action.value"
              (openedChange)="updateActionOnTypeChange(action)">
              <mat-option *ngFor="let item of valueListWithTags" [value]="item.id">{{ item.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="action-details" *ngIf="action.type === 'set-fragment'">
          <mat-form-field>
            <mat-label translate="account/links/transformations/actions/set-fragment/value"></mat-label>
            <input matInput [(ngModel)]="action.value" type="text" />
          </mat-form-field>
        </div>
        <div class="action-details" *ngIf="action.type === 'wrap-url'">
          <mat-form-field>
            <mat-label translate="account/links/transformations/actions/wrap-url/url"></mat-label>
            <input matInput [(ngModel)]="action.url" type="text" />
          </mat-form-field>
          <mat-form-field>
            <mat-label translate="account/links/transformations/actions/wrap-url/name"></mat-label>
            <input matInput [(ngModel)]="action.name" type="text" />
          </mat-form-field>
        </div>
        <div class="action-example">
          <span translate="account/links/transformations/actions/example-result"></span> &nbsp;
          <code>{{ actionResultExample(action) }}</code>
        </div>
      </div>
      <button (click)="deleteAction(index)" mat-icon-button color="primary" aria-label="delete exception">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <div>
      <button
        class="ms-auto"
        mat-raised-button
        (click)="addAction()"
        color="accent"
        translate="account/links/transformations/actions/add"
        aria-label="add an action"></button>
    </div>
  </section>

  <mat-slide-toggle
    aria-label="enable aead encryption in transformation"
    color="primary"
    [(ngModel)]="data.transformation.is_encrypted">
    <span translate="account/links/transformations/activate-aead"></span>
  </mat-slide-toggle>
</div>
<div mat-dialog-actions>
  <button
    [mat-dialog-close]="data"
    [disabled]="hostnameControl.invalid"
    type="button"
    color="primary"
    mat-raised-button
    translate="ok"></button>
  <button data-testid="cancel-link-group" type="button" mat-dialog-close mat-raised-button translate="cancel"></button>
</div>
